import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";
import { useAuth } from "../../../Context/AuthProvider";
import { url } from "../../../Constant";
import axios from "axios";
import { toast } from "react-toastify";
import moment from "moment";
import UIkit from "uikit";
import {
  checkIndividualPermission,
  checkPermissions,
} from "../../../Utils/PermissionFunctions";

const customStyles = {
  pagination: {
    style: {
      display: "flex",
      justifyContent: "space-between",
    },
  },
};

const Queue = () => {
  const navigate = useNavigate();
  const { auth } = useAuth();

  const [searchText, setSearchText] = useState("");
  const [queue, setQueue] = useState();
  const [loader, setLoader] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  //   const handleSearch = (event) => {
  //     setSearchText(event.target.value);
  //   };

  const handleOpenDeleteModal = () => {
    UIkit.modal("#modal-example").show();
  };

  useEffect(() => {
    if (queue !== undefined) {
      // Target dynamically generated nav for pagination
      const paginationNav = document.querySelector("nav.rdt_Pagination");
      if (paginationNav) {
        // Select the elements for the left group (first span and first div)
        const firstSpanElement = paginationNav.querySelector("span");
        const firstDivElement =
          paginationNav.querySelector("div:first-of-type");

        // Select the elements for the right group (second span and last div)
        const secondSpanElement = paginationNav.querySelector(
          "span:nth-of-type(2)"
        );
        const lastDivElement = paginationNav.querySelector("div:last-of-type");

        // Create a div for the left group
        const leftGroup = document.createElement("div");
        leftGroup.classList.add("left-group"); // Add custom class
        leftGroup.style.display = "flex"; // Apply flex display
        leftGroup.style.alignItems = "center"; // Ensure alignment

        // Create a div for the right group
        const rightGroup = document.createElement("div");
        rightGroup.classList.add("right-group"); // Add custom class
        rightGroup.style.display = "flex"; // Apply flex display
        rightGroup.style.alignItems = "center"; // Ensure alignment
        rightGroup.style.marginLeft = "auto"; // Push to the right side

        // Append the first span and first div into the left group
        if (firstSpanElement && firstDivElement) {
          leftGroup.appendChild(firstSpanElement);
          leftGroup.appendChild(firstDivElement);
        }

        // Append the second span and last div into the right group
        if (secondSpanElement && lastDivElement) {
          rightGroup.appendChild(secondSpanElement);
          rightGroup.appendChild(lastDivElement);
        }

        // Prepend the left group to the pagination nav
        paginationNav.prepend(leftGroup);

        // Check if rightGroup has any children before appending it
        if (rightGroup.childElementCount > 0) {
          paginationNav.appendChild(rightGroup);
        }
      }
    }
  }, [queue]);

  const handleCloseDeleteModal = () => {
    UIkit.modal("#modal-example").hide();
  };

  const columns = [
    {
      name: "QUEUE NAME",
      selector: (row) => row.queue_name,
    },
    {
      name: "QUEUE TYPE",
      selector: (row) => row.queue_type,
    },
    {
      name: "EXTENSIONS",
      cell: (row) => <div className="table-nowrap">{String(row.sip_id)}</div>,
    },
    {
      name: "Created",
      selector: (row) => moment(row.created_at).format("MM-DD-YYYY h:mm"),
    },

    {
      name: "ACTION",
      selector: (row) => (
        <div>
          <button
            className={"btn-design greenColor"}
            onClick={() => {
              navigate(auth.role === "3" ? "/edit-queues" : "/edit-queue", {
                state: row,
              });
            }}
          >
            Edit
          </button>

          <button
            className={"btn-design alertColor"}
            style={{ marginLeft: "10px" }}
            onClick={() => {
              // handleOpenDeleteModal(row);
              deleteStatus(row);
            }}
          >
            Delete
          </button>
        </div>
      ),
    },
    {
      name: "",
      selector: (row) => (
        <div>
          <button
            className={
              row.queue_status === 1
                ? "btn-design greenColor"
                : "btn-design redColor"
            }
            onClick={() => handleStatus(row)}
          >
            {row.queue_status === 0 ? "De-Activated" : "Activated"}
          </button>
        </div>
      ),
    },
  ];
  const columnsWithPermissions = [
    {
      name: "QUEUE NAME",
      selector: (row) => row.queue_name,
    },
    {
      name: "QUEUE TYPE",
      selector: (row) => row.queue_type,
    },
    {
      name: "EXTENSIONS",
      cell: (row) => <div className="table-nowrap">{String(row.sip_id)}</div>,
    },
    {
      name: "Created",
      selector: (row) => moment(row.created_at).format("MM-DD-YYYY h:mm"),
    },
  ];

  const handleStatus = (row) => {
    let api = "";
    if (auth.role === "2") {
      api = "queue-status-change";
    } else {
      api = "user-queue-status-change";
    }

    axios
      .post(
        url + api,
        {
          vpbx_id: auth.vpbx_id,
          queue_id: row.queue_id,
          queue_status: row.queue_status == 1 ? 0 : 1,
        },
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      )
      .then(function (result) {
        if (result.data.status === true) {
          toast.success("Status Changed Successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 1200,
          });
          setTimeout(() => {
            getQueue();
          }, 1500);
        }
      });
  };
  const getColumns = () => {
    if (
      auth.role === "3" &&
      !checkIndividualPermission("queue", "read_and_write")
    ) {
      return columnsWithPermissions;
    } else {
      return columns;
    }
  };
  const deleteStatus = (row) => {
    let api = "";
    if (auth.role === "2") {
      api = "delete-queue";
    } else {
      api = "user-delete-queue";
    }
    axios
      .post(
        url + api,
        {
          vpbx_id: auth.vpbx_id,
          queue_id: row.queue_id,
        },
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      )
      .then(function (result) {
        if (result.data.status === true) {
          toast.warning("Status Delete Successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 1200,
          });
          setTimeout(() => {
            getQueue();
          }, 1500);
        }
      });
  };
  const getQueue = () => {
    setLoader(true);
    let data = {
      vpbx_id: auth.vpbx_id,
    };
    let api = "";
    if (auth.role === "2") {
      api = "view-queue";
    } else {
      api = "user-view-queue";
    }

    axios
      .post(url + api, data, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      })
      .then(
        (response) => {
          if (response.status === 200) {
            setQueue(response.data.data);
          }
          setLoader(false);
        },
        (error) => {
          console.log(error);
          setLoader(false);
        }
      );
  };
  useEffect(() => {
    getQueue();
  }, []);

  const filteredQueueData = queue?.filter((val) => {
    return (
      val.queue_name?.toLowerCase().includes(searchText.toLowerCase()) ||
      val.queue_type?.toLowerCase().includes(searchText.toLowerCase())
    );
  });

  // console.log(checkIndividualPermission("queue", "read_and_write"));
  return (
    <div className="dashboardWrp">
      <div className="uk-container uk-container-large">
        <div className="dashboardTop">
          <div uk-grid="" className="uk-grid uk-grid-small">
            <div className="uk-width-2-3">
              <div className="dashboardIntro">
                <h3>VPBX MANAGER</h3>
                {auth.role === "2" && (
                  <p>
                    Use this page to create new call routing, forward calls, set
                    up conference calls, manage existing extensions, and much
                    more.
                  </p>
                )}
              </div>
            </div>
            <div className="uk-width-1-1 ">
              <ul
                className="uk-subnav callSwitcher"
                id="renderSwitcher"
                uk-switcher="connect: .callClass"
              >
                {(auth.role === "2" || auth.role === "3") && (
                  <>
                    {auth.role === "2" || checkPermissions("ivr-flow") ? (
                      <li
                        onClick={() => navigate("/ivr-flow", { replace: true })}
                      >
                        <a href="#">IVR flow</a>
                      </li>
                    ) : null}
                    {auth.role === "2" || checkPermissions("extensions") ? (
                      <li
                        onClick={() =>
                          navigate("/extensions", { replace: true })
                        }
                      >
                        <a href="#">Extensions</a>
                      </li>
                    ) : null}
                    {auth.role === "2" || checkPermissions("Forwarding") ? (
                      <li
                        onClick={() =>
                          navigate("/call-forwarding", { replace: true })
                        }
                      >
                        <a href="#">Forwarding</a>
                      </li>
                    ) : null}
                    {auth.role === "2" || checkPermissions("conferencing") ? (
                      <li
                        onClick={() =>
                          navigate("/call-conferencing", { replace: true })
                        }
                      >
                        <a href="#">Conferencing</a>
                      </li>
                    ) : null}
                    {auth.role === "2" || checkPermissions("list-manager") ? (
                      <li
                        onClick={() =>
                          navigate("/list-manager", { replace: true })
                        }
                      >
                        <a href="#">List manager</a>
                      </li>
                    ) : null}
                    {auth.role === "2" || checkPermissions("sound-settings") ? (
                      <li
                        onClick={() =>
                          navigate("/sound-setting", { replace: true })
                        }
                      >
                        <a href="#">Sound settings</a>
                      </li>
                    ) : null}
                    {auth.role === "2" || checkPermissions("hours") ? (
                      <li onClick={() => navigate("/hour", { replace: true })}>
                        <a href="#">Hours</a>
                      </li>
                    ) : null}
                    {auth.role === "2" || checkPermissions("customized-ivr") ? (
                      <li
                        onClick={() =>
                          navigate("/customized-ivr", { replace: true })
                        }
                      >
                        <a href="#">Customized IVR</a>
                      </li>
                    ) : null}
                    {auth.role === "2" || checkPermissions("queue") ? (
                      <li
                        className="uk-active"
                        onClick={() => navigate("/queue", { replace: true })}
                      >
                        <a href="#">Queue</a>
                      </li>
                    ) : null}
                    {auth.role === "2" ? (
                      <li
                        onClick={() => navigate("/prompt", { replace: true })}
                      >
                        <a href="#">prompt</a>
                      </li>
                    ) : null}
                  </>
                )}
              </ul>
            </div>
          </div>
          <ul className="uk-switcher uk-margin callClass">
            {(auth.role === "2" || auth.role === "3") && (
              <>
                {auth.role === "2" || checkPermissions("ivr-flow") ? (
                  <li onClick={() => navigate("/ivr-flow")}></li>
                ) : null}

                {auth.role === "2" || checkPermissions("extensions") ? (
                  <li></li>
                ) : null}

                {auth.role === "2" || checkPermissions("Forwarding") ? (
                  <li></li>
                ) : null}

                {auth.role === "2" || checkPermissions("conferencing") ? (
                  <li></li>
                ) : null}
                {auth.role === "2" || checkPermissions("list-manager") ? (
                  <li></li>
                ) : null}

                {auth.role === "2" || checkPermissions("sound-settings") ? (
                  <li></li>
                ) : null}

                {auth.role === "2" || checkPermissions("hours") ? (
                  <li></li>
                ) : null}

                {auth.role === "2" || checkPermissions("customized-ivr") ? (
                  <li></li>
                ) : null}

                {auth.role === "2" || checkPermissions("queue") ? (
                  <li>
                    <div className="ImcomingCallMain RoutingMain">
                      <div className="uk-grid" uk-grid="">
                        <div className="uk-width-1-2">
                          <div className="uk-text-left">
                            <div className="MainHeading">
                              <h6>Queue</h6>
                            </div>
                          </div>
                        </div>

                        {(auth.role === "2" ||
                          (auth.role === "3" &&
                            checkIndividualPermission(
                              "queue",
                              "read_and_write"
                            ))) && (
                          <div className="uk-width-1-2">
                            <div className="uk-text-right">
                              <span>
                                <div className="uk-inline uk-text-left">
                                  <Link
                                    className="exportData-button NewFlow"
                                    to="/add-queue"
                                  >
                                    Add Queue
                                  </Link>
                                </div>
                              </span>
                              <span className="primary-color"></span>
                            </div>
                          </div>
                        )}
                      </div>

                      <div>
                        {loader ? (
                          <div uk-spinner="" className="tableloader"></div>
                        ) : (
                          <DataTable
                            columns={
                              // auth.role === "3" &&
                              // checkIndividualPermission("queue", "read_and_write") === true
                              //   ? columnsWithPermissions
                              //   : columns
                              getColumns()
                            }
                            data={filteredQueueData}
                            pagination
                            customStyles={customStyles} // Apply custom styles
                          />
                        )}
                      </div>
                      {/* Delete Confirmation Modal */}

                      {/* <div id="modal-example" uk-modal>
    <div class="uk-modal-dialog uk-modal-body">
        <h2 class="uk-modal-title">Delete</h2>
        <p>Are you sure you want to delete?</p>
        <p class="uk-text-center">
          <button class="uk-button uk-button-primary" type="button" onClick={deleteStatus}>Yes</button>
            <button class="uk-button uk-button-default uk-modal-close" type="button">No</button>
        </p>
    </div>
</div> */}

                      {/* <div id="modal-example" className="customModal ModalStyle" uk-modal>
          <div className="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
            <div className="filterModalContent">
              <div className="modalHeading">
                <h4>Delete Confirmation</h4>
              </div>
              <div className="modalForm">
                <p>Are you sure you want to delete?</p>
                <button className="exportData-button" onClick={() => deleteStatus()}>Yes</button>
                <button className="exportData-button uk-modal-close" uk-close >No</button>
              </div>
            </div>
          </div>
        </div> */}
                    </div>
                  </li>
                ) : null}
                {auth.role === "2" ? <li></li> : null}
              </>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Queue;
